import { render, staticRenderFns } from "./idp-configdetail-dialog.vue?vue&type=template&id=af687bae&scoped=true&"
import script from "./idp-configdetail-dialog.vue?vue&type=script&lang=tsx&"
export * from "./idp-configdetail-dialog.vue?vue&type=script&lang=tsx&"
import style0 from "./idp-configdetail-dialog.vue?vue&type=style&index=0&id=af687bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af687bae",
  null
  
)

export default component.exports